import React from "react";

interface Props {
    alertType: string;
    alertMessage: string;
}

const Alert = (props: Props) => {
    const { alertType, alertMessage } = props;

    return (
        <div className={`alert ${alertType ? "alert-" + alertType : ""}`} role="alert">
            {alertMessage}
        </div>
    );
};

export default Alert;
